import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg width={16} height={16} fill="none" {...props}>
    <Path
      d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
      stroke="#00B56B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8 5.813a.563.563 0 1 0 0-1.126.563.563 0 0 0 0 1.125Z"
      fill="#00B56B"
    />
    <Path
      d="M7.5 7.5H8V11h.5"
      stroke="#00B56B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

const InfoIcon = memo(SvgComponent);
export default InfoIcon;
